import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.CATEGORY_CREATE_SUCCESS, category: data.category });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.CATEGORY_CREATE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const categoryCreate = (data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.CATEGORY_CREATE_REQUEST });

    axios.post('/categories', data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
